import { Link } from "react-router-dom";
import { rupee } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function ProductCard({ p }) {
  const { add } = useCart();
  return (
    <div className="group" data-testid={`product-card-${p.sku}`}>
      <Link to={`/product/${p.id}`}>
        <div className="product-image relative">
          <img src={p.images?.[0]} alt={p.name} loading="lazy" />
          {p.new_arrival && <span className="absolute top-3 left-3 bg-[#FBF9F5] text-[10px] uppercase tracking-[0.2em] px-2 py-1">New</span>}
          {p.bestseller && <span className="absolute top-3 right-3 bg-[#C5A059] text-[#121212] text-[10px] uppercase tracking-[0.2em] px-2 py-1">Bestseller</span>}
        </div>
      </Link>
      <div className="mt-4 flex items-start justify-between gap-4">
        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#8C867D]">{p.category}</div>
          <Link to={`/product/${p.id}`} className="text-sm md:text-base font-medium mt-1 block hover:text-[#C5A059]">{p.name}</Link>
          <div className="mt-1 text-sm">
            {p.discount_price ? (
              <><span className="text-[#5B1C22]">{rupee(p.discount_price)}</span> <span className="line-through text-[#8C867D] text-xs ml-2">{rupee(p.price)}</span></>
            ) : rupee(p.price)}
          </div>
        </div>
        <button onClick={() => add(p)} className="text-[10px] uppercase tracking-[0.2em] border-b border-[#121212] pb-[2px] hover:text-[#C5A059] hover:border-[#C5A059]" data-testid={`product-card-add-${p.sku}`}>Add</button>
      </div>
    </div>
  );
}
